var map = {
	"./calendar.css": 149,
	"./challenge.css": 36,
	"./collaborator-custom.css": 235,
	"./drag.css": 233,
	"./events.css": 543,
	"./file.css": 112,
	"./font-awesome.min.css": 252,
	"./fonts/FontAwesome.otf": 544,
	"./fonts/fontawesome-webfont.eot": 545,
	"./fonts/fontawesome-webfont.svg": 546,
	"./fonts/fontawesome-webfont.ttf": 547,
	"./fonts/fontawesome-webfont.woff": 548,
	"./fonts/fontawesome-webfont.woff2": 549,
	"./footer.css": 250,
	"./home.css": 550,
	"./images/AAGP-Logo.png": 551,
	"./images/AAPG-Logo.png": 158,
	"./images/AAPG-Pivoting-1.png": 552,
	"./images/AAPG-Pivoting-10.jpg": 553,
	"./images/AAPG-Pivoting-11.jpg": 554,
	"./images/AAPG-Pivoting-2.jpg": 555,
	"./images/AAPG-Pivoting-3.jpg": 556,
	"./images/AAPG-Pivoting-3.png": 557,
	"./images/AAPG-Pivoting-4.jpg": 558,
	"./images/AAPG-Pivoting-5.jpg": 559,
	"./images/AAPG-Pivoting-6.jpg": 560,
	"./images/AAPG-Pivoting-7.jpg": 561,
	"./images/AAPG-Pivoting-8.jpg": 562,
	"./images/AAPG-Pivoting-9.jpg": 563,
	"./images/AAPG-Wiki-Logo.png": 564,
	"./images/BizHub-BAM-logo.png": 565,
	"./images/Criterion-Logo.jpg": 159,
	"./images/Danny-Headshot.jpg": 566,
	"./images/Data-Science-Venn-Diagram-Drew-Conway.png": 567,
	"./images/Deasil-Works-logo.svg": 160,
	"./images/Home-Hero-bg.jpg": 568,
	"./images/Home-Value-Bichronous.jpg": 569,
	"./images/Home-Value-Collaboration.jpg": 570,
	"./images/Home-Value-Marketplace.jpg": 571,
	"./images/MessageUp-logo.jpg": 572,
	"./images/Microsoft-icon.svg": 573,
	"./images/Overlay-play.png": 189,
	"./images/Persona-Structure.svg": 574,
	"./images/Platform-Xrathus-Preview.svg": 575,
	"./images/SEAM-logo.png": 576,
	"./images/SEG-Education-Competency.png": 577,
	"./images/SEG-Education-Courses.png": 578,
	"./images/SEG-Education-Lectures.png": 579,
	"./images/SEG-Education-eLearning.png": 580,
	"./images/SEG-Library-Books-logo.png": 581,
	"./images/SEG-Library-Expanded-Abstracts-logo.png": 582,
	"./images/SEG-Library-Geophysics-logo.png": 583,
	"./images/SEG-Library-Global-Meeting-Abstracts-logo.png": 584,
	"./images/SEG-Library-Interpretation-logo.png": 585,
	"./images/SEG-Library-JEEG-logo.png": 586,
	"./images/SEG-Library-SAGEEP-logo.png": 587,
	"./images/SEG-Library-Seismic-Soundoff-logo.png": 588,
	"./images/SEG-Library-The-Leading-Edge-logo.png": 589,
	"./images/SEG-Library-logo.png": 590,
	"./images/SEG-SoEG-logo.png": 163,
	"./images/SEG-Wiki-logo.png": 591,
	"./images/Sean-Headshot.jpg": 592,
	"./images/Seera-Labs-logo.svg": 161,
	"./images/Seera-Thumb-1.png": 593,
	"./images/Seera-Thumb-2.png": 594,
	"./images/Seera-Thumb-3.png": 595,
	"./images/SeetaResources-logo.svg": 162,
	"./images/Substrates-Connect.svg": 164,
	"./images/Substrates-Hub.svg": 165,
	"./images/Substrates-Marketplace.svg": 166,
	"./images/Substrates-Process.png": 168,
	"./images/Substrates-Section-Connect.jpg": 169,
	"./images/Substrates-Section-Hub.jpg": 170,
	"./images/Substrates-Section-Marketplace.jpg": 171,
	"./images/Substrates-Section-Training.jpg": 172,
	"./images/Substrates-Training.svg": 167,
	"./images/Substrates.svg": 596,
	"./images/Susan-Nash.jpg": 597,
	"./images/Susan-Nash.png": 598,
	"./images/TASKcubes-logo.jpg": 599,
	"./images/Use-Cases-Section-Collaboration.jpg": 173,
	"./images/Use-Cases-Section-Hackathon.jpg": 174,
	"./images/Use-Cases-Section-Ideation.jpg": 175,
	"./images/Use-Cases-Section-Learning.jpg": 176,
	"./images/Use-Cases-Section-Open-Project.jpg": 177,
	"./images/Welcome.jpg": 600,
	"./images/Welcome.mp4": 601,
	"./images/XWidget.png": 130,
	"./images/XWidget.svg": 602,
	"./images/Xrathus-Bichronous-Process-diagram.png": 603,
	"./images/Xrathus-Continuous-diagram.png": 604,
	"./images/Xrathus-Logo-Reversed.png": 605,
	"./images/Xrathus-Logo.png": 606,
	"./images/bg-About-Us.jpg": 607,
	"./images/bg-Hex-Gradient-Connect.jpg": 608,
	"./images/bg-Hex-Gradient-Hub.jpg": 609,
	"./images/bg-Hex-Gradient-White.jpg": 610,
	"./images/bg-Join.jpg": 611,
	"./images/bg-Login.png": 612,
	"./images/bg-Personas.jpg": 613,
	"./images/bg-Welcome.jpg": 614,
	"./images/bg-strip-dark.png": 615,
	"./images/bg-strip-light.png": 616,
	"./images/bg-value-Advancements.jpg": 617,
	"./images/bg-value-Collaboration.jpg": 618,
	"./images/bg-value-Economies.jpg": 619,
	"./images/bg-value-Efficiencies.jpg": 620,
	"./images/bg-value-Opportunities.jpg": 621,
	"./images/icon-Code.svg": 185,
	"./images/icon-Connect-Blogosphere.svg": 622,
	"./images/icon-Connect-Calendar.svg": 188,
	"./images/icon-Connect-Challenges.svg": 186,
	"./images/icon-Connect-Collaboration.svg": 623,
	"./images/icon-Connect-Forums.svg": 187,
	"./images/icon-Connect-Knowledgebase.svg": 624,
	"./images/icon-Dashboard.png": 625,
	"./images/icon-Events.png": 626,
	"./images/icon-Hub-Analytics.svg": 627,
	"./images/icon-Hub-Challenges.svg": 628,
	"./images/icon-Hub-Files.svg": 629,
	"./images/icon-Hub-Models.svg": 630,
	"./images/icon-Hub-Overview.svg": 631,
	"./images/icon-Hub-Pipeline.svg": 632,
	"./images/icon-Hub-Projects.svg": 633,
	"./images/icon-Hub-Publish.svg": 634,
	"./images/icon-Hub-Review.svg": 635,
	"./images/icon-Hub-Sharing.svg": 636,
	"./images/icon-Hub-Toolbox.svg": 637,
	"./images/icon-Hub-Workflow.svg": 638,
	"./images/icon-Marketplace-Solutions.svg": 639,
	"./images/icon-Social-LinkedIn-white.png": 190,
	"./images/icon-Social-LinkedIn.png": 640,
	"./images/icon-Social-Twitter-white.png": 641,
	"./images/icon-Social-Twitter.png": 642,
	"./images/icon-Standards.png": 643,
	"./images/icon-SubdirectoryConnect.svg": 644,
	"./images/icon-SubdirectoryHub.svg": 90,
	"./images/icon-SubdirectoryPrimary.svg": 645,
	"./images/icon-SubdirectoryTraining.svg": 78,
	"./images/icon-Table-Active.svg": 98,
	"./images/icon-Table-Close.svg": 99,
	"./images/icon-Table-Delete.svg": 97,
	"./images/icon-Table-Document.svg": 154,
	"./images/icon-Table-Down-Chevron.svg": 59,
	"./images/icon-Table-Edit.svg": 155,
	"./images/icon-Table-Up-Chevron.svg": 60,
	"./images/icon-Table-View.svg": 94,
	"./images/icon-Training-Courses.svg": 646,
	"./images/icon-Training-Knowledge-Base.svg": 647,
	"./images/icon-User.svg": 132,
	"./images/icon-X.svg": 648,
	"./images/icon-role-Data-Scientist.svg": 191,
	"./images/icon-role-Developer.svg": 192,
	"./images/icon-role-Domain.svg": 193,
	"./images/icon-role-Product-Owner.svg": 194,
	"./images/icon-role-Sponsor.svg": 195,
	"./images/icon-value-Advancements.svg": 649,
	"./images/icon-value-Collaboration.svg": 650,
	"./images/icon-value-Economies.svg": 651,
	"./images/icon-value-Efficiencies.svg": 652,
	"./images/icon-value-Opportunities.svg": 653,
	"./index.css": 253,
	"./modal-video.css": 248,
	"./organization.css": 113,
	"./page-form.css": 216,
	"./page.css": 139,
	"./persona-overlay.css": 254,
	"./persona.css": 255,
	"./scroll-list.css": 93,
	"./search-filter.css": 111,
	"./sidebar.css": 251,
	"./slick-custom.css": 654,
	"./slideshow.css": 215,
	"./static.css": 51,
	"./storyblok-custom.css": 32,
	"./substrates-icon-links.css": 217,
	"./tile.css": 82,
	"./top-bar.css": 249,
	"./training.css": 655,
	"./week-calendar.css": 656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 542;